var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trill-question-item"},[_c('svg-icon',{staticClass:"icon",attrs:{"name":_vm.icon}}),_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.content))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }